import { Route, Routes } from 'react-router-dom';
import NotFoundDetail from '../../components/NotFoundDetail/NotFoundDetail';
import GenerateQrCounterPage from './GenerateQrCounterPage';

const GenerateQrCodeCounter = () => {
    return (
        <Routes>
            <Route index element={<GenerateQrCounterPage />} />
            <Route path="*" element={<NotFoundDetail />} />
        </Routes>
    );
};

export default GenerateQrCodeCounter;
